import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FiCpu,
  FiGlobe,
  FiLayers,
  FiZap,
  FiSmartphone,
  FiShield,
} from "react-icons/fi";

const services = [
  {
    title: "Custom Software",
    description:
      "Operations, school, healthcare, and business-management systems built around your workflow.",
    icon: <FiLayers />,
  },
  {
    title: "Website Development",
    description:
      "Conversion-focused websites that generate leads and strengthen the confidence of your brand.",
    icon: <FiGlobe />,
  },
  {
    title: "Mobile Apps",
    description:
      "Customer-facing products and internal portals designed to be simple and reliable.",
    icon: <FiSmartphone />,
  },
  {
    title: "AI Automation",
    description:
      "Assistants and workflow automation that save time, improve support, and create consistency.",
    icon: <FiCpu />,
  },
  {
    title: "Business Systems",
    description:
      "Inventory, CRM, finance, reporting, and operations dashboards that make teams faster.",
    icon: <FiShield />,
  },
  {
    title: "UI/UX Design",
    description:
      "Thoughtful interfaces that make your tools pleasant to use and easy to adopt.",
    icon: <FiZap />,
  },
];

function Services() {
  return (
    <div>
      <section className="page-hero accent-bg">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <h1 className="hero-title">Services built for growth</h1>
              <p className="hero-copy mt-3">
                We combine strategy, design, and engineering to create digital
                products that solve business problems and create measurable
                value.
              </p>
              <Button
                as={Link}
                to="/contact"
                className="rounded-pill px-4 mt-3"
              >
                Discuss your project
              </Button>
            </Col>
            <Col lg={5}>
              <div className="page-card">
                <h5 className="fw-bold">What we deliver</h5>
                <p className="text-muted mb-0">
                  Every engagement begins with listening. We turn your goals
                  into a practical roadmap, a clear experience, and a product
                  your team can use with confidence.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="section-shell">
        <Container>
          <Row className="g-4">
            {services.map((service) => (
              <Col md={6} lg={4} key={service.title}>
                <Card className="service-card h-100">
                  <div className="service-icon">{service.icon}</div>
                  <h5 className="fw-bold">{service.title}</h5>
                  <p className="text-muted mb-0">{service.description}</p>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default Services;
